import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { EngineerAppComponent } from './app.component';

import { ProfileModule } from './modules/profile/profile.module';
import { AppMaterialComponentsModule } from './app-material-components';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing-module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  OptionSetsApiService,
  LicensevalidationService
} from './data-services';
import { OptionSetsGqlService } from './data-services/dynamics';
import { RegistrationModule } from './modules/registration/registration.module';
import { 
  ApiService, 
  LicensedDesignProfessionalApiService, 
  LicensedDesignProfessionalGqlService,
  DialogSolutionDeployingComponent,
  AppLoadService,
  RecaptchaService,
  EbbIntegrationModule
} from '@ebb-v2/ebb-integration';
import { DeviceDetectorService } from 'ngx-device-detector';
import {  IConfig, provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { APOLLO_PROVIDERS } from './apollo.config';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({ declarations: [
       EngineerAppComponent,
        DialogSolutionDeployingComponent,
    ],
    imports: [BrowserModule, 
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        EbbIntegrationModule,
        RegistrationModule,
        AppMaterialComponentsModule,
        AppRoutingModule,
        ProfileModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxMaskDirective, NgxMaskPipe,
        RecaptchaModule,
        RecaptchaFormsModule], providers: [
        ApiService, provideNgxMask(),
        AppLoadService, DeviceDetectorService,
        { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
        { provide: OptionSetsApiService, useClass: OptionSetsGqlService },
        { provide: LicensedDesignProfessionalApiService, useClass: LicensedDesignProfessionalGqlService },
        {
            provide: RECAPTCHA_SETTINGS,
            useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
                siteKey: appLoadService.getRecaptchaKey()
            }),
            deps: [AppLoadService]
        },
        LicensevalidationService,
        RecaptchaService,
        ...APOLLO_PROVIDERS,
    ], bootstrap: [EngineerAppComponent],})
export class EngineerAppModule {}
